import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTaxbuzzComponent } from './simple-icons-taxbuzz.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTaxbuzzComponent ],
    exports:      [ SimpleIconsTaxbuzzComponent ],
    bootstrap:    []
})
export class SimpleIconsTaxbuzzModule {}
